/*
|--------------------------------------------------------------------------
| Vendor resources imports
|--------------------------------------------------------------------------
*/

import 'bootstrap';
import 'magnific-popup';
// Vendor css
import '../scss/vendor.scss';
